const RICH_CONTENT_SEARCH_TERMS = {
	'phone-sales': [
		'contacts',
		'phones',
		'calls',
		'sales',
		'demos',
		'managers',
		'leases'
	],
	'phone-service': [
		'contacts',
		'phones',
		'calls',
		'services',
		'oil changes',
		'battery',
		'batteries',
		'tires',
		'snow tires',
		'managers',
		'car problems'
	],
	'phone-parts': [
		'contacts',
		'phones',
		'calls',
		'parts',
		'oil changes',
		'battery',
		'batteries',
		'plows',
		'boxes',
		'tires',
		'snow tires',
		'managers'
	],
	'phone-commercial': [
		'contacts',
		'phones',
		'calls',
		'commercials',
		'managers'
	],
	email: [
		'contacts',
		'addresses',
		'sales',
		'services',
		'parts',
		'commercials',
		'messages',
		'chats',
		'emails',
		'managers'
	],
	address: ['contacts', 'addresses', 'directions', 'maps', 'locations'],
	'hours-sales': [
		'contacts',
		'hours',
		'sales',
		'times',
		'opens',
		'closes',
		'demos',
		'leasees'
	],
	'hours-service': [
		'contacts',
		'hours',
		'servicees',
		'times',
		'opens',
		'closes',
		'oil changes',
		'battery',
		'batteries',
		'tires',
		'snow tires',
		'car problems'
	],
	'hours-parts': [
		'contacts',
		'hours',
		'parts',
		'times',
		'opens',
		'closes',
		'oil changes',
		'battery',
		'batteries',
		'plows',
		'boxes',
		'tires',
		'snow tires'
	],
	'hours-commercial': [
		'contacts',
		'hours',
		'commercials',
		'times',
		'opens',
		'closes'
	]
};

export default function getRichContentResults(
	searchTerm,
	minimumInputCharactersToTriggerResults,
	richContentToHide = []
) {
	const richContentToDisplay = [];
	if (searchTerm.length >= minimumInputCharactersToTriggerResults) {
		searchTerm.split(' ').forEach((token) => {
			Object.keys(RICH_CONTENT_SEARCH_TERMS).forEach(
				(richContentName) => {
					if (richContentToHide.indexOf(richContentName) === -1) {
						RICH_CONTENT_SEARCH_TERMS[richContentName].forEach(
							(keyword) => {
								if (
									richContentToDisplay.indexOf(
										richContentName
									) === -1 &&
									keyword
										.trim()
										.toLowerCase()
										.indexOf(token.trim().toLowerCase()) !==
										-1
								) {
									richContentToDisplay.push(richContentName);
								}
							}
						);
					}
				}
			);
		});
	}
	return richContentToDisplay;
}
